<template>
  <div class="kr-standard-form">
    <div class="kr-standard-form-item" v-if="form.category">
      <el-checkbox class="kr-standard-form-item-checkbox" v-model="form.category.isActive" @change="checkboxChange(form.category, ...arguments)">门类</el-checkbox>
      <div class="kr-standard-form-input-panel">
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">显示名称</label>
          <el-input v-model="form.category.label" :disabled="!form.category.isActive"></el-input>
        </div>
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">API Name</label>
          <el-input v-model="form.category.apiName" :disabled="form.category.disabled || !form.category.isActive"></el-input>
        </div>
      </div>
    </div>
    <div class="kr-standard-form-item" v-if="form.category_big">
      <el-checkbox class="kr-standard-form-item-checkbox" v-model="form.category_big.isActive" @change="checkboxChange(form.category_big, ...arguments)">大类</el-checkbox>
      <div class="kr-standard-form-input-panel">
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">显示名称</label>
          <el-input v-model="form.category_big.label" :disabled="!form.category_big.isActive"></el-input>
        </div>
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">API Name</label>
          <el-input v-model="form.category_big.apiName" :disabled="form.category_big.disabled || !form.category_big.isActive"></el-input>
        </div>
      </div>
    </div>
    <div class="kr-standard-form-item" v-if="form.category_middle">
      <el-checkbox class="kr-standard-form-item-checkbox" v-model="form.category_middle.isActive" @change="checkboxChange(form.category_middle, ...arguments)">中类</el-checkbox>
      <div class="kr-standard-form-input-panel">
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">显示名称</label>
          <el-input v-model="form.category_middle.label" :disabled="!form.category_middle.isActive"></el-input>
        </div>
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">API Name</label>
          <el-input v-model="form.category_middle.apiName" :disabled="form.category_middle.disabled || !form.category_middle.isActive"></el-input>
        </div>
      </div>
    </div>
    <div class="kr-standard-form-item" v-if="form.category_small">
      <el-checkbox class="kr-standard-form-item-checkbox" v-model="form.category_small.isActive" @change="checkboxChange(form.category_small, ...arguments)">小类</el-checkbox>
      <div class="kr-standard-form-input-panel">
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">显示名称</label>
          <el-input v-model="form.category_small.label" :disabled="!form.category_small.isActive"></el-input>
        </div>
        <div class="kr-standard-form-input">
          <label class="kr-standard-form-input-label">API Name</label>
          <el-input v-model="form.category_small.apiName" :disabled="form.category_small.disabled || !form.category_small.isActive"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    fieldName: String
  },
  data() {
    return {
      form: {
        category: {
          isActive: false,
          disabled: false,
          type: "category",
          label: '',
          baseLabel: '门类',
          apiName: 'Field_' + kr.random.string_number(4)
        },
        category_big: {
          isActive: false,
          disabled: false,
          type: "category_big",
          label: '',
          baseLabel: '大类',
          apiName: 'Field_' + kr.random.string_number(4)
        },
        category_middle: {
          isActive: false,
          disabled: false,
          type: "category_middle",
          label: '',
          baseLabel: '中类',
          apiName: 'Field_' + kr.random.string_number(4)
        },
        category_small: {
          isActive: false,
          disabled: false,
          type: "category_small",
          label: '',
          baseLabel: '小类',
          apiName: 'Field_' + kr.random.string_number(4)
        }
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    fieldName: {
      handler(val) {
        val = val || '';
        let keys = Object.keys(this.form);
        keys.forEach((item) => {
          if (!this.form[item].isActive) {
            this.form[item].label = val + '_' + this.form[item].baseLabel;
          }
        })
      },
      immediate: true
    },
    value: {
      handler(val) {
        if (val) {
          let { form } = this;
          if (form !== val) {
            let keys = Object.keys(val);
            let formKeys = Object.keys(form);
            formKeys.forEach((key) => {

             if (keys.includes(key)) {
               form[key] = {
                 ...form[key],
                 ...val[key],
                 disabled: true
               }
             } else {
               delete form[key];
             }

            });
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    checkboxChange(data, val) {
      let { form } = this;
      let type = data.type;
      let keys = Object.keys(form);
      let currentIndex = keys.indexOf(type);
      if (val) {
        for (let i = 0; i < currentIndex; i ++) {
          form[keys[i]].isActive = val;
        }
      } else {
        for (let j = currentIndex + 1; j < keys.length; j ++) {
          form[keys[j]].isActive = val;
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .kr-standard-form {
    .kr-standard-form-item {
      line-height: normal;
      font-size: 12px;

      .kr-standard-form-item-checkbox {
        height: 16px;
        line-height: 16px;
        margin: 8px 0 8px;
      }

      .kr-standard-form-input-panel {
        display: flex;

        .kr-standard-form-input {
          flex-grow: 1;

          .kr-standard-form-input-label {
            margin-bottom: 4px;
            display: inline-block;
          }
        }

        .kr-standard-form-input:nth-of-type(2) {
          margin-left: 12px;
        }
      }
    }
  }

</style>